import { render, staticRenderFns } from "./dr-widget-list-component.vue?vue&type=template&id=31892995&"
import script from "./dr-widget-list-component.vue?vue&type=script&lang=js&"
export * from "./dr-widget-list-component.vue?vue&type=script&lang=js&"
import style0 from "./dr-widget-list-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports